import { createContext } from "react";

const itemContext = createContext();

export default itemContext;
